import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryModuleApiSuffixModels, INVENTORY_COMPONENT } from '@app/modules';
import { AppState } from '@app/reducers';
import { CrudType, IApplicationResponse, ModulesBasedApiSuffix,  prepareGetRequestHttpParams, prepareRequiredHttpParams, RxjsService,  PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes, SnackbarService, exportList, getPDropdownData, onActionSubmittedUtil, datePipeConversion, SERVER_REQUEST_DATE_TRANSFORM } from '@app/shared';
import { CrudService } from '@app/shared/services';
import { SupplierReturnListFilterModel } from '@modules/inventory/models/SupplierReturnListFilter.model';
import { Store } from '@ngrx/store';
import { forkJoin } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../shared/models/prime-ng-table-list-component-variables.model';
import { handleNgrxStoreData, processStoreData } from '@app/shared/utils/combine-page-level.utils';
@Component({
  selector: 'supplier-list',
  templateUrl: './supplier-list.component.html',
  styleUrls: ['./supplier-list.component.scss']
})
export class SupplierListComponent extends PrimeNgTableVariablesModel implements OnInit {
  showFilterForm: boolean = false;
  supplierReturnFilterForm: FormGroup;
  supplierObservable;
  primengTableConfigProperties: any;
  supplierList = [];
  statusList = [];
  warehouseList = [];
  ReferenceList = [];
  row: any = {}
  filterObject;
  otherParams;
  startTodayDate = 0;
  constructor(private commonService: CrudService, private formBuilder: FormBuilder, private router: Router, private rxjsService: RxjsService,
    private activatedRoute: ActivatedRoute, private store: Store<AppState>, private snackbarService: SnackbarService) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "Return to Supplier",
      shouldShowBreadCrumb: false,
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Inventory Management', relativeRouterUrl: '/inventory/dashboard' }, { displayName: 'Stock Return', relativeRouterUrl: '' }, { displayName: 'Return to Supplier' }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Return to Supplier',
            dataKey: 'supplierId',
            enableBreadCrumb: true,
            enableAction: true,
            enableScrollable: true,
            enableFieldsSearch: true,
            enableHyperLink: true,
            enableAddActionBtn: true,
            enablePrintBtn: true,
            printTitle: 'Packing-dashboard Report',
            printSection: 'print-section0',
            cursorLinkIndex: 0,
            columns: [{ field: 'supReturnNumber', header: 'Return to Supplier No' },
            { field: 'supplierReturnStatusName', header: 'Status' },
            { field: 'supplierName', header: 'Supplier Name' },
            { field: 'orderNumber', header: 'PO Number' },
            { field: 'barcode', header: 'PO Barcode' },
            { field: 'warehouseName', header: 'Warehouse' },
            { field: 'createdBy', header: 'Created By' },
            { field: 'createdDate', header: 'Created Date',isDateTime:true },

            ],
            shouldShowCreateActionBtn: true,
            shouldShowFilterActionBtn: true,
            isDateWithTimeRequired: true,
            enableExportBtn: true,
            apiSuffixModel: InventoryModuleApiSuffixModels.SUPPLIER_RETURN,
            moduleName: ModulesBasedApiSuffix.INVENTORY,
          },
        ]
      }
    }
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.selectedTabIndex = (Object.keys(params['params']).length > 0) ? +params['params']['tab'] : 0;
      this.primengTableConfigProperties.selectedTabIndex = this.selectedTabIndex;
      this.primengTableConfigProperties.breadCrumbItems[2].displayName = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].caption;
    });
  }

  ngOnInit(): void {
    handleNgrxStoreData((response) => {
      let processData = processStoreData(response, this.primengTableConfigProperties, INVENTORY_COMPONENT.SUPPLIER_RETURN_REQUESTS);
      this.primengTableConfigProperties = processData.primengTableConfigProperties
      this.loggedInUserData = processData.loggedInUserData
    }, this.store);
    this.getRequiredListData();
    this.displayAndLoadFilterData();
    this.getRequiredListData();
    this.getReferenceListArr();
  }
  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }
  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  getRequiredListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    let InventoryModuleApiSuffixModels: InventoryModuleApiSuffixModels;
    InventoryModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    otherParams = {
      ...otherParams,
      IsAll: true,
      UserId: this.loggedInUserData.userId,
      ReturnType: this.selectedTabIndex == 0 ? 'new' : 'faulty'
    }
    this.otherParams = otherParams;

    this.commonService.get(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize,
        otherParams)
    ).subscribe(data => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.dataList = data.resources;
        this.totalRecords = data.totalCount;
      } else {
        this.dataList = null;
        this.totalRecords = 0;
      }
    })
  }

  onCRUDRequested(type: CrudType | string, row?: any, unknownVar?: any): void {
    switch (type) {
      case CrudType.CREATE:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].canCreate) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        if (unknownVar) {
          unknownVar.IsAll = true;
          unknownVar.UserId = this.loggedInUserData.userId,
            unknownVar.ReturnType = this.selectedTabIndex == 0 ? 'new' : 'faulty';
        }
        unknownVar = { ...unknownVar, ...this.filterObject }
        this.first = row?.pageIndex && row?.pageSize ? row?.pageIndex * row?.pageSize : 0;
        this.getRequiredListData(row?.pageIndex, row?.pageSize, unknownVar)
        break;
      case CrudType.EDIT:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
      case CrudType.FILTER:
        // this.displayAndLoadFilterData();
        this.showFilterForm = !this.showFilterForm;
        break;
      case CrudType.EXPORT:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].canExport) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        let pageIndex = this.row && this.row["pageIndex"] ? this.row["pageIndex"] : 0;
        let pageSize = this.row && this.row["pageSize"] ? this.row["pageSize"] : 10;
        this.exportList(pageIndex, pageSize);
        break;
      default:
    }
  }

  exportList(pageIndex?: any, pageSize?: any) {
    exportList(this.otherParams, 0, pageSize, ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.SUPPLIER_RETURN_TO_EXPORT, this.commonService, this.rxjsService, 'Return to Supplier');
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string): void {
    switch (type) {
      case CrudType.CREATE:
        this.router.navigate(['inventory/suppliers/return/create'], {
          queryParams: { type: 'create' }, skipLocationChange: true
        });
        break;
      case CrudType.VIEW:
        this.router.navigate(['inventory/suppliers/return/return-view'], {
          queryParams: {
            id: editableObject['supReturnId'],
            type: 'update'
          }, skipLocationChange: true
        });
        break;
    }
  }

  displayAndLoadFilterData(): void {
    this.createSupplierReturnFilterForm();
    this.warehouseList = [];
    forkJoin([
      this.commonService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.UX_WAREHOUSES, undefined, false, prepareRequiredHttpParams({ userId: this.loggedInUserData?.userId })),
      this.commonService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.UX_SUPPLIERRETURNSTATUS, undefined, false),
      this.commonService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.UX_SUPPLIER_RETURN, undefined, false, prepareRequiredHttpParams({ userId: this.loggedInUserData?.userId })),
    ]).subscribe((response: IApplicationResponse[]) => {
      response.forEach((resp: IApplicationResponse, ix: number) => {
        if (resp.isSuccess && resp.statusCode === 200) {
          switch (ix) {
            case 0:
              this.warehouseList = getPDropdownData(resp.resources);
              break;
            case 1:
              this.statusList = resp.resources;
              break;
            case 2:
              this.supplierList = getPDropdownData(resp.resources);
              if (this.supplierReturnFilterForm.get('warehouseId').value?.length) {
                this.onWarehouseChage(this.supplierReturnFilterForm.get('warehouseId').value);
              }
              break;
          }
        }
      })
      this.rxjsService.setGlobalLoaderProperty(false);
    })
    this.supplierReturnFilterForm.get('warehouseId').valueChanges.subscribe(val => {
      if (val != null) {
        if (val.length > 0) {
          this.getReferenceList(Array.prototype.map.call(val, function (item) { return item; }).join(',')).subscribe((response: IApplicationResponse) => {
            this.ReferenceList = [];
            response.resources.forEach(x => this.ReferenceList.push({ value: x.id, label: x.displayName }))
            this.rxjsService.setGlobalLoaderProperty(false);
          })
        }
      }
      else {
        this.ReferenceList = [];
        this.supplierReturnFilterForm.get('referenceId').setValue(null);
        this.getReferenceListArr();
      }
    });
  }
  onWarehouseChage(val) {
    if (val != null) {
      if (val.length > 0) {
        this.getReferenceList(Array.prototype.map.call(val, function (item) { return item; }).join(',')).subscribe((response: IApplicationResponse) => {
          this.ReferenceList = [];
          response.resources.forEach(x => this.ReferenceList.push({ value: x.id, display: x.displayName }))
          this.rxjsService.setGlobalLoaderProperty(false);
        })
      }
    }
    else {
      this.ReferenceList = [];
      this.supplierReturnFilterForm.get('referenceId').setValue(null);
      this.getReferenceListArr();
    }
  }
  createSupplierReturnFilterForm(supplierReturnListFilterModel?: SupplierReturnListFilterModel) {
    let supplierReturnFilterModel = new SupplierReturnListFilterModel(supplierReturnListFilterModel);
    this.supplierReturnFilterForm = this.formBuilder.group({});
    Object.keys(supplierReturnFilterModel).forEach((key) => {
      if (typeof supplierReturnFilterModel[key] === 'string') {
        this.supplierReturnFilterForm.addControl(key, new FormControl(supplierReturnFilterModel[key]));
      }
    });
    // Subscribe to fromDate changes to clear toDate if fromDate becomes greater than toDate
    this.supplierReturnFilterForm.get('fromDate').valueChanges.subscribe((fromDate: Date) => {
      if (fromDate) {
        const toDateControl = this.supplierReturnFilterForm.get('toDate');
        if (toDateControl.value && toDateControl.value < fromDate) {
          toDateControl.setValue(null);
        }
      }
    });
  }

  getReferenceList(warehouseId) {
    return this.commonService.get(ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.UX_PURCHASEORDERS_BY_WAREHOUSE,
      undefined,
      false,
      prepareGetRequestHttpParams(null, null, {
        WarehouseIds: warehouseId ? warehouseId : '',
        userId: this.loggedInUserData.userId
      })
    );
  }
  getReferenceListArr() {
    this.commonService.get(ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.UX_PURCHASEORDERS_BY_WAREHOUSE,
      undefined,
      false,
      prepareGetRequestHttpParams(null, null, { userId: this.loggedInUserData.userId })
    ).subscribe((response: IApplicationResponse) => {
      this.ReferenceList = [];
      response.resources.forEach(x => this.ReferenceList.push({ value: x.id, label: x.displayName }))
      this.rxjsService.setGlobalLoaderProperty(false);
    })
  }

  resetFilter() {
    this.supplierReturnFilterForm.reset();
    this.filterObject = null;
    this.getRequiredListData();
    this.showFilterForm = !this.showFilterForm;
  }

  submitFilter() {
    let data = Object.assign({},
      (this.supplierReturnFilterForm.get('warehouseId').value === null || this.supplierReturnFilterForm.get('warehouseId').value.length == 0) ? null : { WarehouseId: Array.prototype.map.call(this.supplierReturnFilterForm.get('warehouseId').value, function (item) { return item; }).join(',') },
      (this.supplierReturnFilterForm.get('referenceId').value === null || this.supplierReturnFilterForm.get('referenceId').value.length == 0) ? null : { ReferenceId: Array.prototype.map.call(this.supplierReturnFilterForm.get('referenceId').value, function (item) { return item; }).join(',') },
      (this.supplierReturnFilterForm.get('statusId').value == '' || this.supplierReturnFilterForm.get('statusId').value == null) ? null : { StatusId: this.supplierReturnFilterForm.get('statusId').value },
      (this.supplierReturnFilterForm.get('fromDate').value == null || this.supplierReturnFilterForm.get('fromDate').value == '') ? null : { FromDate: datePipeConversion(this.supplierReturnFilterForm.get('fromDate').value, SERVER_REQUEST_DATE_TRANSFORM) },
      (this.supplierReturnFilterForm.get('toDate').value == '' || this.supplierReturnFilterForm.get('toDate').value == null) ? null : { ToDate: datePipeConversion(this.supplierReturnFilterForm.get('toDate').value,SERVER_REQUEST_DATE_TRANSFORM) },
      (this.supplierReturnFilterForm.get('poBarCode').value == '' || this.supplierReturnFilterForm.get('poBarCode').value == null) ? null : { POBarcodes: this.supplierReturnFilterForm.get('poBarCode').value },
      (this.supplierReturnFilterForm.get('supplierId').value == '' || this.supplierReturnFilterForm.get('supplierId').value == null) ? null : { SupplierId: Array.prototype.map.call(this.supplierReturnFilterForm.get('supplierId').value, function (item) { return item; }).join(',') },
      { IsAll: true }, { ReturnType: this.selectedTabIndex == 0 ? 'new' : 'faulty' }, { UserId: this.loggedInUserData.userId }
    );
    this.filterObject = data;
    this.onCRUDRequested('get');
    this.showFilterForm = !this.showFilterForm;
  }
}
